import React from 'react'

const Loader = (props) => {
	if (props.type === "text") {
		return <div className="fc-ta-c fc-pv-64">Loading ...</div>	
	}
	return <div className="fc-ta-c fc-pv-64">...</div>
}

export default Loader